import { render, staticRenderFns } from "./Accountdesp.vue?vue&type=template&id=bbd90bfc&scoped=true"
import script from "./Accountdesp.vue?vue&type=script&lang=js"
export * from "./Accountdesp.vue?vue&type=script&lang=js"
import style0 from "./Accountdesp.vue?vue&type=style&index=0&id=bbd90bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd90bfc",
  null
  
)

export default component.exports